import { defineMessages } from 'react-intl';

export default defineMessages({
  editorPlaceholder: {
    id: 'app.form.rte.editorPlaceholder',
    defaultMessage: 'Enter text here...',
  },
  showMore: {
    id: 'app.form.rte.showMore',
    defaultMessage: 'Show more',
  },
  showLess: {
    id: 'app.form.rte.showLess',
    defaultMessage: 'Show less',
  },
  askAI: {
    id: 'app.form.rte.askAI',
    defaultMessage: 'Ask AI',
  },
  variablePlaceholder: {
    id: 'app.form.rte.variablePlaceholder',
    defaultMessage: 'Select a variable to insert',
  },
  fallbackLabel: {
    id: 'app.form.rte.fallback.label',
    defaultMessage: 'Fallback',
  },
  tooltipToPersonalizationTokens: {
    id: 'app.form.rte.tooltipToPersonalizationTokens',
    defaultMessage:
      'This is a personalization token. These tokens are placeholders that are filled in for each individual recipient, allowing us to send personalized emails to multiple recepients.',
  },
  chipLabel: {
    id: 'app.form.rte.chipLabel',
    defaultMessage: '{type}',
  },

  fallbackTitle: {
    id: 'app.form.rte.fallbackTitle',
    defaultMessage: '{type}',
  },
  tableAddRowAbove: {
    id: 'app.form.rte.tableAddRowAbove',
    defaultMessage: 'Add row above',
  },
  tableAddRowBelow: {
    id: 'app.form.rte.tableAddRowBelow',
    defaultMessage: 'Add row below',
  },
  tableAddColLeft: {
    id: 'app.form.rte.tableAddColLeft',
    defaultMessage: 'Add column left',
  },
  tableAddColRight: {
    id: 'app.form.rte.tableAddColRight',
    defaultMessage: 'Add column right',
  },
  tableMergeCells: {
    id: 'app.form.rte.tableMergeCells',
    defaultMessage: 'Merge cells',
  },
  tableSplitCell: {
    id: 'app.form.rte.tableSplitCell',
    defaultMessage: 'Split cell',
  },
  tableDeleteRow: {
    id: 'app.form.rte.tableDeleteRow',
    defaultMessage: 'Delete row',
  },
  tableDeleteCol: {
    id: 'app.form.rte.tableDeleteCol',
    defaultMessage: 'Delete column',
  },
  tableDeleteTable: {
    id: 'app.form.rte.tableDeleteTable',
    defaultMessage: 'Delete table',
  },
  tableInsertTable: {
    id: 'app.form.rte.tableInsertTable',
    defaultMessage: 'Insert table',
  },
  tableToggleHeaderRow: {
    id: 'app.form.rte.tableToggleHeaderRow',
    defaultMessage: 'Toggle header row',
  },
  headingNormal: {
    id: 'app.form.rte.headingNormal',
    defaultMessage: 'Normal text',
  },
  headingH1: {
    id: 'app.form.rte.headingH1',
    defaultMessage: 'Heading 1',
  },
  headingH2: {
    id: 'app.form.rte.headingH2',
    defaultMessage: 'Heading 2',
  },
  headingH3: {
    id: 'app.form.rte.headingH3',
    defaultMessage: 'Heading 3',
  },
  linkInsert: {
    id: 'app.form.rte.linkInsert',
    defaultMessage: 'Insert link',
  },
  linkEdit: {
    id: 'app.form.rte.linkEdit',
    defaultMessage: 'Edit link',
  },
  linkRemove: {
    id: 'app.form.rte.linkRemove',
    defaultMessage: 'Remove link',
  },
  linkOpen: {
    id: 'app.form.rte.linkOpen',
    defaultMessage: 'Open link',
  },
  linkPlaceholder: {
    id: 'app.form.rte.linkPlaceholder',
    defaultMessage: 'Enter a URL...',
  },
  toolBold: {
    id: 'app.form.rte.toolBold',
    defaultMessage: 'Bold',
  },
  toolItalic: {
    id: 'app.form.rte.toolItalic',
    defaultMessage: 'Italic',
  },
  toolUnderline: {
    id: 'app.form.rte.toolUnderline',
    defaultMessage: 'Underline',
  },
  toolStrike: {
    id: 'app.form.rte.toolStrike',
    defaultMessage: 'Strikethrough',
  },
  toolHighlight: {
    id: 'app.form.rte.toolHighlight',
    defaultMessage: 'Highlight',
  },
  toolBulletList: {
    id: 'app.form.rte.toolBulletList',
    defaultMessage: 'Bulleted list',
  },
  toolOrderedList: {
    id: 'app.form.rte.toolOrderedList',
    defaultMessage: 'Numbered list',
  },
  toolLists: {
    id: 'app.form.rte.toolLists',
    defaultMessage: 'Lists',
  },
  toolHorizontalRule: {
    id: 'app.form.rte.toolHorizontalRule',
    defaultMessage: 'Horizontal line',
  },
});
